const cities = [
  'Montpellier', 'Sète', 'Agde', 'Béziers', 'Frontignan', 'La Grande-Motte',
  'Lattes', 'Palavas-les-Flots', 'Mauguio', 'Castelnau-le-Lez',
  'Juvignac', 'Saint-Jean-de-Védas', 'Villeneuve-lès-Maguelone',
  'Pérols', 'Marseillan', 'Vias', 'Balaruc-les-Bains', 'Mèze',
];

export default function ZoneIntervention() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-3">
            Zone d'intervention dans l'Hérault
          </h2>
          <p className="text-secondary-500 font-body text-base md:text-lg max-w-xl mx-auto">
            Nous intervenons à Montpellier, dans sa métropole et sur tout le littoral héraultais.
          </p>
        </div>

        <div className="bg-background-50 rounded-xl p-8 md:p-10">
          <div className="flex flex-wrap gap-2 justify-center">
            {cities.map((city) => (
              <span
                key={city}
                className="bg-white text-primary-500 font-label font-semibold text-sm px-4 py-2 rounded-full whitespace-nowrap border border-background-200"
              >
                {city}
              </span>
            ))}
          </div>
          <p className="text-center text-secondary-500 text-sm font-body mt-6">
            Et toutes les communes environnantes de la région montpelliéraine et du littoral héraultais.
          </p>
        </div>
      </div>
    </section>
  );
}